module.exports = __webpack_public_path__ + "static/pic07-32b633b0c2ab3ffdef5a3eda4573ea52.jpg";